export class LapsFormatError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'LapsFormatError'
  }
}
